// removed by extract-text-webpack-plugin
module.exports = {"imageContainer":"G272352","image":"G3fe950"};